import { render } from "./status.vue?vue&type=template&id=d88e0ca6&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"

import "./status.vue?vue&type=style&index=0&id=d88e0ca6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88e0ca6"]])

export default __exports__